module.exports = __webpack_public_path__ + "static/img/step-1012.c8e3016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-1012.png
// module id = mjCf
// module chunks = 1